import { useMemo } from 'react';

import { useSession } from '@/context/SessionContext';
import { useScope } from '@workspace/scope-context';

export interface TenantFeatureMapState {
  featureMap?: Record<string, boolean>;
  featureTenantId?: string;
}

export function useTenantFeatureMap(): TenantFeatureMapState {
  const { session } = useSession();
  const { activeTenant } = useScope();

  return useMemo(() => {
    const tenantFeatures = session?.features?.tenant;
    if (!tenantFeatures) {
      return { featureMap: undefined, featureTenantId: undefined };
    }

    const tenantIds = Object.keys(tenantFeatures);
    let featureTenantId = activeTenant?.id && tenantFeatures[activeTenant.id] ? activeTenant.id : undefined;
    if (!featureTenantId && tenantIds.length === 1) {
      featureTenantId = tenantIds[0];
    }

    const featureMap = featureTenantId ? tenantFeatures[featureTenantId] ?? {} : undefined;

    return { featureMap, featureTenantId };
  }, [session?.features?.tenant, activeTenant?.id]);
}
